'use strict';
require('./warnAboutDeprecatedCJSRequire.js')('createBrowserHistory');
module.exports = require('./index.js').createBrowserHistory;



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/history/createBrowserHistory.js
// module id = 536
// module chunks = 99